import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SCHOOLS = function (state, payload) {
  state.schools = payload
}
mutations.TOUR_COMPANIES = function (state, payload) {
  state.tourCompanies = payload
}
mutations.AVAILABLE_COUNTRIES = function (state, payload) {
  state.availableCountries = payload
}
mutations.RESET_COND = function (state, payload) {
  state.cond = {}
}

const state = {
  rows: {
    draft: [],
    confirmed: [],
    canceled: []
  },
  row: {},
  tabIndex: 0,
  cond: {},
  schools: [],
  tourCompanies: [],
  availableCountries: []
}
const actions = {
  init: ({ commit, state }, cond) => {
    console.debug('called M0301Bidding init')
    return client.postData({ data: { init: { api: 'M0301BiddingService.getInit', input: cond } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('FIND_ALL', data.init.output.bidding)
          commit('SCHOOLS', data.init.output.schools)
          commit('TOUR_COMPANIES', data.init.output.tourCompanies)
          commit('AVAILABLE_COUNTRIES', data.init.output.availableCountries.map(item => item.tour_destination))
        }
      }).catch((err) => { throw err })
  },
  doSearch: ({ commit, state }, condition) => {
    console.debug('called M0301Bidding search')
    return client.postData({ data: { search: { api: 'M0301BiddingService.doSearch', input: condition } } })
      .then((data) => {
        if (data.search.output.status === false) { throw new Error(data.search.output.message) } else {
          commit('FIND_ALL', data.search.output)
        }
      }).catch((err) => { throw err })
  },
  saveStatus: ({ state, dispatch }, input) => {
    console.debug('called M0301Bidding saveStatus')
    return client.postData({ data: { save: { api: 'M0302BiddingCompanyStatusService.saveStatus', input: input } } })
      .then((data) => {
        if (data.save.output.status === false) { throw new Error(data.save.output.message) } else {
          dispatch('doSearch', state.cond)
        }
      }).catch((err) => { throw err })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
